// extracted by mini-css-extract-plugin
export default {"container":"DM-z"};